;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "cards",
  props: ["status_api_url", "invoice_no", "bill_ref", "callback_url"],
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      service_name: null,
      agent_fee: 0,
      fee: 0,
      total_amount: 0
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.logo = this.$attrs["logo"];
    this.service_name = this.$attrs["service_name"];
    this.set_total_amount();
    $("#kcbCashModal").on("hidden.bs.modal", function () {
      _this.destroyTimer();
    });
  },
  methods: {
    destroyTimer: function destroyTimer() {
      this.$refs.timer.destroyTimer();
    },

    set_total_amount: function set_total_amount() {
      this.total_amount = parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"kcbCashModal","tabindex":"-1","role":"dialog","aria-labelledby":"kcbCashModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('a',{staticClass:"btn btn-white",attrs:{"href":""}},[_vm._v("Download Instructions")])]),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay using KCB Cash")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.total_amount))])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('p',{staticClass:"mb-0"},[_vm._v("Service: "+_vm._s(_vm.service_name))]),_vm._v(" "),_c('p',[_vm._v("Application No: "+_vm._s(_vm.bill_ref))]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("Visit KCB Branch")]),_vm._v(" "),_c('li',[_vm._v("Ask to make E-Citizen cash payment")]),_vm._v(" "),_c('li',[_vm._v("Bill Reference Number: "+_vm._s(_vm.invoice_no))]),_vm._v(" "),_c('li',[_vm._v("Amount. "+_vm._s(_vm.currency)+" "+_vm._s(_vm.total_amount))])]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("\n                    Once you have made the deposit. Click complete below.\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"\n                    card-footer\n                    d-flex\n                    justify-content-end\n                    align-items-center\n                  "},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":_vm.destroyTimer}},[_vm._v("Cancel")]),_vm._v(" "),_c('complete-button',{ref:"timer",attrs:{"gateway":"kcbcash","status_api_url":_vm.status_api_url,"invoice_no":_vm.invoice_no,"callback_url":_vm.callback_url}})],1)])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-674372ab", __vue__options__)
  } else {
    hotAPI.reload("data-v-674372ab", __vue__options__)
  }
})()}